export function normalizePipeIdsForGroup(raw: unknown): string[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((item) => {
      if (item == null) return '';
      if (typeof item === 'object' && item !== null && 'id' in item) {
        const id = (item as { id?: unknown }).id;
        return id != null ? String(id) : '';
      }
      return String(item);
    })
    .filter(Boolean);
}
